import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import {
  PRICING,
  SAVING,
  LAUNCH_PROMO_ACTIVE,
  formatIDR,
  MAYAR_CONSENT_NOTICE,
} from "@/config/landing";

const INCLUDED = [
  "Akses ke seluruh fitur aplikasi KalkuBisnis saat ini.",
  "Satu video tutorial penggunaan.",
  "Aktivasi akun setelah pembayaran terverifikasi oleh administrator.",
];

export function Pricing() {
  return (
    <section id="harga" className="scroll-mt-20 bg-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="mx-auto max-w-xl">
            <div className="overflow-hidden rounded-3xl border border-teal-200 bg-white shadow-xl shadow-teal-900/5">
              <div className="bg-teal-600 px-6 py-3 text-center">
                <p className="text-sm font-bold uppercase tracking-widest text-white">
                  Harga Spesial Peluncuran
                </p>
              </div>
              <div className="p-6 text-center sm:p-10">
                {LAUNCH_PROMO_ACTIVE && (
                  <div className="flex items-center justify-center gap-3">
                    <p className="text-lg font-semibold text-slate-400 line-through decoration-red-500 decoration-2">
                      {formatIDR(PRICING.REGULAR)}
                    </p>
                    <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700 ring-1 ring-emerald-200">
                      Hemat {formatIDR(SAVING)}
                    </span>
                  </div>
                )}
                <p
                  data-testid="launch-price"
                  className="mt-3 text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl"
                >
                  {formatIDR(PRICING.LAUNCH)}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">
                  Dapatkan akses KalkuBisnis dan video tutorial penggunaan dengan satu kali
                  pembayaran, tanpa biaya perpanjangan tahunan selama layanan tetap beroperasi.
                </p>
                <ul className="mx-auto mt-6 max-w-sm space-y-3 text-left">
                  {INCLUDED.map((item) => (
                    <li key={item} className="flex items-start gap-2.5">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-50 text-teal-700">
                        <Check className="h-3 w-3" aria-hidden="true" />
                      </span>
                      <span className="text-sm text-slate-700">{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <CtaButton testid="pricing-cta-button" className="w-full sm:w-auto" />
                </div>
                <p className="mt-4 text-xs text-slate-500">
                  Pembayaran dilakukan melalui Mayar. Akun dibuat setelah pembayaran terverifikasi.
                </p>
                <p className="mt-2 text-xs leading-relaxed text-slate-400">
                  Dengan melanjutkan pembelian, kamu menyatakan telah membaca dan menyetujui{" "}
                  <Link
                    to="/syarat-dan-ketentuan"
                    data-testid="pricing-terms-link"
                    className="font-medium text-teal-700 underline underline-offset-2 hover:text-teal-800"
                  >
                    Syarat dan Ketentuan
                  </Link>{" "}
                  KalkuBisnis.
                </p>
                {/* Catatan untuk pemilik: salin teks consent ini ke deskripsi produk Mayar:
                    "{MAYAR_CONSENT_NOTICE}" */}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
